import React, {useState, useContext} from 'react';
import "../Styles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import ChangePassword from '../../common/ChangePassword';
import DigitalSignature from './DigitalSignature';

import {LangCtx} from "../../../lib/context";

const DoctorSettings = (props) => {
    const [current, setTab] = useState("CP");
    const {l} = useContext(LangCtx);

    return(
        <div className="baseContainer">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.settings}</h2>
                </div>
                <div className="tabCol">
                    <div className="row hndlpdn08">
                        <div className={current === "CP" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CP")}>
                            <span>{l.change_pwd}</span>
                        </div>
                        <div className={current === "DS" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("DS")}>
                            <span>{l.dig_sig}</span>
                        </div>
                    </div>
                </div>
            </div>
            {current === "CP" && <ChangePassword />}
            {current === "DS" && <DigitalSignature />}
        </div>
    )
}

export default DoctorSettings;